import React, { useState } from "react";
import Header from "../components/common-web/Header";
import ResizablePanel from "../components/common/ResizablePanel";
import {
  Architectural,
  ComputerIcon,
  CorporateFare,
  SidebarCloseIcon,
  SidebarOpenIcon,
  SlideShow,
} from "../Icons";
import TdViewerSidebar from "../components/td-viewer/TdViewerSideBar";
import TdViewerContent from "../components/td-viewer/TdViewerContent";
import Navbar from "../components/common-web/Navbar";

export default function TdViewer() {
  const [isOpenSidebar, setIsOpenSidebar] = useState(true);
  const [activeTab, setActiveTab] = useState(0);

  return (
    <main className="bg-[#262d44] h-screen flex flex-col overflow-hidden">
      <Header>
        <Navbar path="/3d-viewer" />
      </Header>

      <div className="flex-1 flex flex-col overflow-hidden ">
        <ResizablePanel
          direction="horizontal"
          initialSize={268} // Adjust width when collapsed
          minSize={180}
          maxSize={500}
          isShowSidebar={isOpenSidebar}
          panelContent={
            <div className="flex flex-col bg-[#F1F1F1] text-[#242424] h-full">
              {/* Header Section */}
              <div className="flex items-center justify-between py-[5px] px-2.5 bg-white">
                <h6 className="text-[#242424] text-[12px] font-bold">
                  On / Off & Search
                </h6>
                <button
                  className="w-6 aspect-square flex items-center justify-center"
                  onClick={() => setIsOpenSidebar(!isOpenSidebar)}
                >
                  {isOpenSidebar ? <SidebarCloseIcon /> : <SidebarOpenIcon />}
                </button>
              </div>

              {/* Sidebar Content */}
              {isOpenSidebar ? (
                <div className="flex-1 flex flex-col justify-between overflow-hidden transition-all duration-300">
                  <div className="custom-scrollbar flex-1 overflow-y-auto ">
                    <TdViewerSidebar />
                  </div>

                  {/* Footer */}

                  <div className="bg-white p-3 ">
                    <div className="flex items-center justify-between max-w-[200px] mx-auto gap-2">
                      {[
                        { id: 0, icon: <ComputerIcon /> },
                        { id: 1, icon: <CorporateFare /> },
                        { id: 2, icon: <Architectural /> },
                        { id: 3, icon: <SlideShow /> },
                      ].map((item, index) => (
                        <button
                          key={index}
                          onClick={() => setActiveTab(index)}
                          className={`max-w-8 w-full aspect-square rounded-[6px] flex items-center justify-center p-1.5 transition-colors duration-200 ${
                            activeTab === index
                              ? "bg-[#E96F0C]"
                              : "bg-[#E6E6E6]"
                          }`}
                        >
                          {React.cloneElement(item.icon, {
                            color: activeTab === index ? "#fff" : "#242424",
                          })}
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          }
        >
          {/* Main Content */}
          <div className="flex flex-col h-full">
            <TdViewerContent />
          </div>
        </ResizablePanel>
      </div>
    </main>
  );
}
